<template>
  <div :class="['pagination-container', { hidden, transparent }]">
    <el-pagination :current-page.sync="currentPage" :page-size.sync="pageSize"
      :layout="layout" :page-sizes="pageSizes" :total="total" :background="background" v-bind="$attrs"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </div>
</template>

<script>
import { scrollTo } from '@/util/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50, 100, 500]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    transparent: {
      type: Boolean,
      default: false
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style scoped>
.pagination-container { background: #fff; text-align: left; }
.pagination-container.hidden { display: none; }
.pagination-container.transparent { background: transparent; }
.pagination-container.transparent ::v-deep .el-pagination { color: #cfe3ff; }
.pagination-container.transparent ::v-deep .el-pagination .el-pager li { color: #cfe3ff; border: 1px solid rgba(255,255,255,0.12); border-radius: 8px; background: transparent; }
.pagination-container.transparent ::v-deep .el-pagination .el-pager li.active { color: #ffffff; background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.2); }
.pagination-container.transparent ::v-deep .el-pagination .btn-next, 
.pagination-container.transparent ::v-deep .el-pagination .btn-prev, 
.pagination-container.transparent ::v-deep .el-pagination .el-pagination__jump, 
.pagination-container.transparent ::v-deep .el-pagination .el-pagination__sizes { color: #8aa4c9; }
.pagination-container.transparent ::v-deep .el-pagination .btn-next:hover, 
.pagination-container.transparent ::v-deep .el-pagination .btn-prev:hover { color: #cfe3ff; }
</style>
